import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { OurServices } from './pages/OurServices';
import { BookingForm } from './pages/BookingForm';
import { HomeCleaningForm } from './pages/HomeCleaningForm';
import { DeepCleaningForm } from './pages/DeepCleaningForm';
import { MoveInOutForm } from './pages/MoveInOutForm';
export function App() {
  return <div className="min-h-screen w-full bg-light font-sans text-primary overflow-x-hidden" data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Navbar data-id="element-2" />
      <Routes data-id="element-3">
        <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
        <Route path="/services" element={<OurServices data-id="element-7" />} data-id="element-6" />
        <Route path="/book/commercial" element={<BookingForm data-id="element-9" />} data-id="element-8" />
        <Route path="/book/home-cleaning" element={<HomeCleaningForm data-id="element-11" />} data-id="element-10" />
        <Route path="/book/deep-cleaning" element={<DeepCleaningForm data-id="element-13" />} data-id="element-12" />
        <Route path="/book/move-in-out" element={<MoveInOutForm data-id="element-15" />} data-id="element-14" />
      </Routes>
      <Footer data-id="element-16" />
    </div>;
}